import { useTheme } from "@mui/material";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import dayjs, { Dayjs } from "dayjs";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { FilterItem, LocaleKey } from "src/components/tables/senec-data-grid/filter-utils/senecFilterOperators";

/**
 * MUI Date picker component for the SenecDataGrid column filter
 */
export const SenecDataGridDateInput = ({
    item,
    applyValue,
    locale,
}: {
    item: FilterItem;
    applyValue: (item: FilterItem) => void;
    locale: LocaleKey;
}) => {
    const currentTheme = useTheme();

    const theme = createTheme({
        ...currentTheme,
        components: {
            ...currentTheme.components,
            MuiOutlinedInput: {
                styleOverrides: {
                    notchedOutline: {
                        border: 0,
                    },
                    input: {
                        padding: 0,
                    },
                },
            },
        },
    });

    const handleFilterChange = (value: Dayjs | null) => {
        if (value) applyValue({ ...item, value: value.toISOString() });
    };

    return (
        <ThemeProvider theme={theme}>
            <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale={locale}>
                <DatePicker
                    value={dayjs()}
                    data-testid="filter-date-picker"
                    onAccept={(date: Dayjs | null) => {
                        handleFilterChange(date);
                    }}
                />
            </LocalizationProvider>
        </ThemeProvider>
    );
};
